import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ProjectsService } from "../../../_services/projects.service";
import { DashboardFilterService } from "./dashboard-filter.service";
import { ToastrService } from "ngx-toastr";

import { ProvinceService } from "app/_services/province.service";

const moment = require("moment");

@Component({
  selector: "app-dashboard-filter",
  templateUrl: "./dashboard-filter.component.html",
  styleUrls: ["./dashboard-filter.component.scss"],
})
export class DashboardFilterComponent {
  @Output() filterEmitter = new EventEmitter<any>();
  @Input() projectFilter: boolean = true;
  @Input() brandFilter: boolean = false;
  @Input() provinceFilter: boolean = false;
  @Input() spamFilter: boolean = true;
  @Input() isDashboard5: boolean = false;
  @Input() filterSentiment: boolean = false;
  @Input() painpointActive: boolean = false;
  @Input() excel_btn: boolean = false;
  @Input() sourceByTopicFilter: boolean = false;

  @Input() chu_de_thao_luan_filter: boolean = false;

  @Input() singleSelectionProject: boolean = true;

  @Input() filterByTime: boolean = false;

  isAdmin: Boolean = false;
  /* DATEPICKER SETTING - START */
  daterange: any = {
    start: moment().subtract(0, "days").startOf("day"),
    end: moment().subtract(0, "days").endOf("day"),
  };
  options: any = {
    locale: {
      format: "DD/MM/YYYY", //  HH:mm:ss
      applyLabel: "Áp dụng",
      cancelLabel: "Hủy",
      fromLabel: "Từ",
      toLabel: "Tới",
      customRangeLabel: "Tùy chọn",
      daysOfWeek: ["CN", "Hai", "Ba", "Tư", "Năm", "Sáu", "Bảy"],
      monthNames: [
        "Tháng 1 -",
        "Tháng 2 -",
        "Tháng 3 -",
        "Tháng 4 -",
        "Tháng 5 -",
        "Tháng 6 -",
        "Tháng 7 -",
        "Tháng 8 -",
        "Tháng 9 -",
        "Tháng 10 -",
        "Tháng 11 -",
        "Tháng 12 -",
      ],
    },
    timePicker: false,
    datePicker: false,
    alwaysShowCalendars: false,
    ranges: {
      // 'Toàn thời gian': [moment('20170429').startOf('day'), moment().endOf('day')],
      // '24 giờ': [moment().subtract(1, 'day'), moment()],
      "Hôm nay": [moment().startOf("day"), moment().endOf("day")],
      // 'Hôm qua': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
      "Tuần này": [moment().startOf("isoWeek"), moment().endOf("isoWeek")],
      "Tuần trước": [
        moment().subtract(1, "week").startOf("isoWeek"),
        moment().subtract(1, "week").endOf("isoWeek"),
      ],
      "Tháng này": [moment().startOf("month"), moment().endOf("month")],
      "Tháng trước": [
        moment().subtract(1, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
      ],
    },
    opens: "right",
    maxDate: moment().endOf("day").toDate(),
    timePicker24Hour: false,
    timePickerSeconds: false,
  };
  /* END */

  // ITEM CHỦ ĐỀ
  brandDropDownSettings = {
    singleSelection: false,
    text: "Chọn thương hiệu",
    selectAllText: "Chọn tất cả",
    unSelectAllText: "Bỏ chọn tất cả",
    enableSearchFilter: false,
    badgeShowLimit: 2,
  };
  projectDropDownSettings = {
    singleSelection: this.singleSelectionProject,
    text: "Chọn chủ đề",
    selectAllText: "Chọn tất cả",
    unSelectAllText: "Bỏ chọn tất cả",
    enableSearchFilter: false,
    badgeShowLimit: 2,
  };
  projectDropDownSettings2 = {
    singleSelection: true,
    text: "Chọn chủ đề thảo luận",
    selectAllText: "Chọn tất cả",
    unSelectAllText: "Bỏ chọn tất cả",
    enableSearchFilter: false,
    badgeShowLimit: 2,
    noDataLabel: "Không có chủ đề thảo luận!",
  };
  provinceDropDownSettings = {
    singleSelection: false,
    text: "Chọn tỉnh thành",
    selectAllText: "Chọn tất cả",
    unSelectAllText: "Bỏ chọn tất cả",
    badgeShowLimit: 2,
    enableSearchFilter: true,
  };
  projectSelected = [];
  projects = [];

  brands = [];
  brandSelectedFilter = [];

  provinceSelected = [];
  provinces = [];

  typeSentimentPost = "all";

  notSpam = false;
  sourceByTopic = "";

  projectsDisscussion = [];
  projectsDisscussionSelected = [];

  typeTime = "collect_date";

  constructor(
    private projectsService: ProjectsService,
    private provinceService: ProvinceService,
    private toastrService: ToastrService,
    private dashboardFilterService: DashboardFilterService
  ) {
    this.isAdmin = localStorage.getItem("currentSmmAccount")
      ? JSON.parse(localStorage.getItem("currentSmmAccount")).admin
      : null;
    this.getProject();
    this.getProvince();
    this.getBrands();
  }

  ngOnInit(): void {
    this.projectDropDownSettings.singleSelection = this.singleSelectionProject;
  }

  getProjectDiscussion() {
    //id : this.currentProjecId

    if (this.projectSelected.length == 0) {
      this.projectsDisscussion = [];
    } else {
      this.projectsDisscussion = [];
      this.projectsDisscussionSelected = [];
      this.projectsService
        .getProjectDiscussionByProject({ projects: this.projectSelected })
        .subscribe((res) => {
          if (res.success) {
            res.data.projectsDiscussion.forEach((element) => {
              let obj = {
                id: element._id,
                itemName: element.name,
                value: element.name,
              };
              this.projectsDisscussion.push(obj);
            });
          }
        });
    }
  }

  checkProjectSelected() {
    if (this.projectSelected.length == 0) {
      this.projectsDisscussion = [];
      let obj = {
        id: 1,
        itemName: "Bạn chưa chọn chủ đề",
        value: "Bạn chưa chọn chủ đề",
      };
      this.projectsDisscussion.push(obj);
    }
    // if(this.projectSelected.length == 0)
    //this.projectsDisscussion = [];
  }

  getProvince() {
    this.provinceService.getProvincesByUser({}).subscribe((res) => {
      if (res.success) {
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          const provinceItem = {
            id: element._id,
            itemName: element.name,
            value: element.name,
          };
          this.provinces.push(provinceItem);
          if (!this.isAdmin) {
            this.provinceSelected.push(provinceItem);
          }
        }
        this.loadReport();
      }
    });
  }
  getBrands() {
    this.projectsService.getBrandsActiveV2().subscribe((res) => {
      if (res.success) {
        res.data.forEach((element) => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name,
            fanpageId: element.fanpageId ? element.fanpageId : null,
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error(
          "Lỗi hệ thống, Vui lòng liên hệ admin",
          " Thông báo"
        );
      }
    });
  }
  getProject() {
    this.projectsService.index().subscribe((response) => {
      if (response.success) {
        for (let index = 0; index < response.data.projects.length; index++) {
          const element = response.data.projects[index];
          if (
            !this.painpointActive ||
            (this.painpointActive && element.painpoint_active)
          ) {
            let obj = {
              id: element._id,
              itemName: element.name,
              value: element.name,
            };
            this.projects.push(obj);
          }
        }
        if (!this.isDashboard5) {
          this.projectSelected.push(this.projects[0]);
        }
      }
    });
  }

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf("day");
    datepicker.end = value.end.endOf("day");
    this.daterange.start = value.start;
    this.daterange.end = value.end;
  }

  loadReport() {
    let filterOptions = this.getFilterOptions();
    this.dashboardFilterService.setData(filterOptions);
    this.dashboardFilterService.openLoader(true);
    this.filterEmitter.emit(filterOptions);
    var app = this;
    setTimeout(function () {
      app.dashboardFilterService.openLoader(false);
    }, 1900);
  }

  private getFilterOptions() {
    let provinceSelected = this.provinceSelected.map(
      (provinceItem) => provinceItem.value
    );
    let projectsSelected = this.projectSelected;
    let projectSelectedIds = [];
    for (const item of projectsSelected) {
      projectSelectedIds.push(item.id);
    }
    let filterOptions = {
      gte: moment(
        new Date(
          this.daterange.start.format("YYYY-MM-DDTHH:mm:ss.SSSZ")
        ).getTime()
      ).valueOf(),
      lte: moment(
        new Date(
          this.daterange.end.format("YYYY-MM-DDTHH:mm:ss.SSSZ")
        ).getTime()
      ).valueOf(),
      start: this.daterange.start,
      end: this.daterange.end,
      projectsSelected: this.projectFilter ? projectsSelected : [],
      brandsSelected: this.brandFilter
        ? this.brandSelectedFilter.length > 0
          ? this.brandSelectedFilter
          : this.brands
        : [],
      projectSelectedIds: this.projectFilter ? projectSelectedIds : [],
      projects: this.projectFilter ? projectsSelected : [],
      label: this.daterange.label,
      sourceByTopic: this.sourceByTopic,
      notSpam: this.notSpam,
      provinces: this.provinceFilter ? provinceSelected : [],
      sentiment:
        this.typeSentimentPost == "all" ? [] : [this.typeSentimentPost],
      typeTime: this.typeTime,
      projectsDisscussionSelected:
        this.projectSelected.length && this.chu_de_thao_luan_filter
          ? this.projectsDisscussionSelected
          : [],
    };
    return filterOptions;
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard-filter/dashboard-filter.component.ts